import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles/Whatsnew.module.css';
import axios from 'axios';
import { Button, Skeleton, SkeletonText } from '@chakra-ui/react';
import ganesh from '../../assets/ganesh.png';
import ListOfFeatures from './ListOfFeatures';
import videoCalling from '../../assets/videoCalling.svg';
import warranty from '../../assets/warranty.svg';
import uniqueDesigns from '../../assets/uniqueDesigns.svg';
import shipping from '../../assets/shipping.svg';
import celebrityFavorite from '../../assets/celebrityFavorite.svg';
const Features = () => {
  const [carouselData, setCarouselData] = useState([]);
  const [loading, setLoading] = useState(false);

  const featureList = [
    {
      img: uniqueDesigns,
      text: '2500+ Unique Designs',
    },
    {
      img: warranty,
      text: 'Assured Warranty',
    },
    {
      img: celebrityFavorite,
      text: 'Celebrity Favorite',
    },
    {
      img: videoCalling,
      text: 'Video Calling Assistance',
    },
  
  ];

  if (loading) {
    return (
      <Skeleton>
        <div className={styles.Whatsnew}></div>
      </Skeleton>
    );
  }

  return (
    <div>
      <div className={`flex flex-col md:flex-row bg-[#ebebeb] p-5`}>
        <div
          className={`flex flex-col w-full md:w-[50%] justify-center items-center gap-4 md:gap-8`}
        >
          <h1 className='font-bold md:text-3xl text-lg text-[#1a1a1a] flex justify-center text-center items-center'>
            Where Tradition Meets Silver Sparkle
          </h1>
          <p className='text-[#333] flex justify-center text-center items-center'>
            100% Hallmarked Silver – Trust You Can Wear
          </p>
          <Link to='/collections'>
            {' '}
            <Button backgroundColor='#D3A143' color='white'>
              Explore Our Offers
            </Button>
          </Link>
        </div>

        <div className={'w-full md:w-[50%]'}>
          <img
            src={ganesh}
            alt='Ganesh Silver Idol'
            className='object-contain'
          />
        </div>
      </div>

      <ListOfFeatures featureList={featureList} />
    </div>
  );
};

export default Features;
